module.exports = __webpack_public_path__ + "img/图片14.a7828a24.png";